import { render, staticRenderFns } from "./CertTest.vue?vue&type=template&id=0978eceb&scoped=true&"
import script from "./CertTest.vue?vue&type=script&lang=js&"
export * from "./CertTest.vue?vue&type=script&lang=js&"
import style0 from "./CertTest.vue?vue&type=style&index=0&id=0978eceb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0978eceb",
  null
  
)

export default component.exports